import Axios from 'axios';
// eslint-disable-next-line
import { promiseTimeout, placeholders, debug, executeScript } from '../utils';

export default {
  data() {
    return {};
  },
  props: {
    /** actual context */
    ctxA: {
      type: Object,
      default: () => ({})
    },
    store: {
      type: Object
    },
    theme: String
  },
  mounted() {
    this.store.eventBus.$on('form.reset', this.reset);
    this.store.eventBus.$on('validate', this.validate);
    const { $ } = window; // For using the global Jquery available
    if (this.ctx.hidden !== true) {
      $(this.$el.querySelector('[data-toggle="tooltip"]')).tooltip();
    }
  },
  // Computed
  computed: {
    /**
     * To handle the value of the field. This will be used as v-model in the fields
     */
    value: {
      get() {
        if (this.formValues[this.ctx.key]) {
          return this.formValues[this.ctx.key];
        }
        if (this.ctx.multiple || this.ctx.type === 'file' || this.ctx.type === 'fw-file') return [];
        return '';
      },
      set(val) {
        this.store.setFormFieldValue(this.ctx.key, val);
      }
    },
    formValues() {
      return this.store.state.formValues;
    },
    context() {
      return this.store.state.context;
    },
    /** actual context merged with default schema/context */
    ctx() {
      return { ...this.defaultSchema, ...this.ctxA };
    }
  },
  // Methods
  methods: {
    /**
     * Initializes the field value.
     * Evaluate default value if its value is not provided.
     */
    async initFieldValue() {
      if (!this.formValues[this.ctx.key]) {
        // if value is not set, default value will be evaluated.
        this.store.setFormFieldValue(this.ctx.key, await this.getDefaultValue());
      }
    },
    async getDefaultValue() {
      const self = this;
      let value;
      let url;
      switch (self.ctx.defaultValue.type) {
        case 'value':
          ({ value } = self.ctx.defaultValue);

          break;
        case 'customScript':
          /**
           * If default value is derived using a script.
           * `this.formValues` and `this.context` will be passed to the script as data.
           * So the user can utilize the filed available in the form.
           */
          // Adding a 10 ms delay to get the default values inside the custom script
          await promiseTimeout(10).then(async () => {
            value = await executeScript(self.ctx.defaultValue.script, {
              data: self.formValues,
              context: self
            });
          });
          // TODO: handle case when script is not defined
          break;
        case 'url':
          /**
           * If type is url, the default value will be loaded from the specified URL.
           * The response should be a json and should contain a field named `value`.
           */
          await promiseTimeout(10).then(() => {
            url = placeholders(self.ctx.defaultValue.url, {
              data: self.formValues,
              context: self.context,
              field: self.ctx
            });
          });
          await Axios.get(url).then(response => {
            ({ value } = response.data);
          });
          // TODO: 1. handle when url is not present
          // TODO: 2. Handle request failure
          break;
        default:
          if (self.ctx.multiple || self.ctx.type === 'file' || self.ctx.type === 'fw-file') {
            value = [];
          } else {
            value = '';
          }
          break;
      }
      debug.log(`Default value evaluated ${self.ctx.key} : ${value}`);
      return value;
    },
    reset() {
      throw new Error(`reset() method is not implmented on "${this.$options.name}" component`);
    },
    validate() {
      throw new Error(`validate() method is not implmented on "${this.$options.name}" component`);
    }
  }
};
